import { create } from 'zustand'

interface InfoPanelState {
  isExpanded: boolean

  expand: () => void
  collapse: () => void
  toggle: () => void
  onManualCameraMove: () => void
}

export const useInfoPanelStore = create<InfoPanelState>((set) => ({
  isExpanded: true,

  expand: () => set({ isExpanded: true }),
  collapse: () => set({ isExpanded: false }),
  toggle: () => set((state) => ({ isExpanded: !state.isExpanded })),
  onManualCameraMove: () => set({ isExpanded: false }),
}))
